import { Component } from '@angular/core';

@Component({
  selector: 'app-logout',
  imports: [],
  templateUrl: './logout.component.html',
  standalone: true,
  styleUrl: './logout.component.sass'
})
export class LogoutComponent {

}
